const SIGNUP_PROGRESS_KEY = "signup_onboarding_progress";

export const saveSignupProgress = (userId, maxStep) => {
  if (!userId) return;
  localStorage.setItem(
    SIGNUP_PROGRESS_KEY,
    JSON.stringify({ userId, maxStep })
  );
};

export const getSignupProgress = (userId) => {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(SIGNUP_PROGRESS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed.userId === userId ? parsed : null;
  } catch {
    return null;
  }
};

export const clearSignupProgress = () => {
  localStorage.removeItem(SIGNUP_PROGRESS_KEY);
};
